export interface DocumentDefinedTermViewModel {
  documentTimestamp?: string;
  libraryShortName: string;
  transactionShortName: string;
  documentShortName: string;
  definedTerm: string;
  definitionCount?: number;
  primaryDomOrder?: number;
  primaryId?: string;
  primaryDomId?: string;
  primaryIsInDefinitionBlock?: boolean;
}

export class DefinedTermOccurenceViewModel {
  term: string;
  occurence: number;
}

export enum TermPosition {
  Final = 'final',
  Original = 'original',
  Both = 'both',
}

export enum TermScope {
  All = 'all',
  DefinitionBlockOnly = 'definitionBlockOnly',
}

export const positionString: Record<TermPosition, string> = {
  [TermPosition.Both]: '',
  [TermPosition.Final]: 'Added',
  [TermPosition.Original]: 'Deleted',
};
